// extracted by mini-css-extract-plugin
export default {"button":"ButtonSecondary_button__X7kEU","ui-spin":"ButtonSecondary_ui-spin__nrC6b"};